import { ActionType } from "../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../react-core/Flux/BaseStore";
import { TaskRequestStatus } from "../../../../Wrap/Constants/Enums/Tasks/TaskRequestStatus";
import { ReportInfo } from "../../../../Wrap/Models/Models/Reports/ReportInfo";
import { ExcelExportDispatcher } from "./Variable";

export interface ExcelExportStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: ReportInfo;
    status?: TaskRequestStatus;
}

export class ExcelExportStatic extends BaseStore<ExcelExportStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(ExcelExportDispatcher, (actionData) => this.onStoreResponse(actionData));
    }

    public getLastResult(): ExcelExportStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): ExcelExportStaticState {
        return { actionType: ActionType.Loading };
    }

    public getData() {
        return this.getState().data;
    }

    public getStatus() {
        return this.getState().status;
    }

    private onStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({
                    actionType: actionData.actionType,
                    isLoading: false,
                    data: actionData.payload,
                });
                break;
            case ActionType.Update:
                this.setState({
                    actionType: actionData.actionType,
                    isLoading: false,
                    status: actionData.payload,
                });
                break;
            case ActionType.Error:
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}
